import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonIcon } from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { closeOutline } from 'ionicons/icons';

@Component({
  selector: 'app-news-popup',
  templateUrl: './news-popup.component.html',
  styleUrls: ['./news-popup.component.scss'],
  standalone: true,
  imports: [CommonModule, IonIcon],
})
export class NewsPopupComponent {
  @Input() open = false;
  @Output() closed = new EventEmitter<void>();

  @Input() payload: any | null = null;

  constructor() {
    addIcons({ closeOutline });
  }

  close() {
    this.open = false;
    this.closed.emit();
  }

  onBackdropClick() {
    this.close();
  }
}
